import base from 'components/base'
import componentInit from 'components/componentInit'
import mainMenu from 'components/mainMenu'
import $ from 'jquery'

class searchResults extends base
{
  elements = {
    container: null,
    showSecondarySnippetsButtons: [],
    hideSecondarySnippetsButtons: []
  }

  constructor(parentElement)
  {
    super()

    $(document).ready(() =>
    {
      this.elements.container = $(parentElement).find('#search-results').get(0)
      this.elements.showSecondarySnippetsButtons = $(this.elements.container).find('button.show-secondary-snippets').get()
      this.elements.hideSecondarySnippetsButtons = $(this.elements.container).find('button.hide-secondary-snippets').get()

      this.bindEvents()
    })
  }

  bindEvents()
  {
    $(this.elements.container).find('a').on('click.'+ module.id, (event) =>
    {
      event.preventDefault()
      mainMenu.changePage($(event.currentTarget).attr('href'), {
        element: event.currentTarget
      })
    })

    $(this.elements.showSecondarySnippetsButtons).on('click.'+ module.id, (event) =>
    {
      let matchElement = $(event.currentTarget).closest('.match').get(0)
      this.showSecondarySnippets(matchElement)
    })

    $(this.elements.hideSecondarySnippetsButtons).on('click.'+ module.id, (event) =>
    {
      let matchElement = $(event.currentTarget).closest('.match').get(0)
      this.hideSecondarySnippets(matchElement)
    })
  }

  showSecondarySnippets(matchElement)
  {
    $(matchElement).toggleClass('show-secondary-snippets', true)
  }

  hideSecondarySnippets(matchElement)
  {
    $(matchElement).toggleClass('show-secondary-snippets', false)
  }
}

componentInit.prototype.callbacks[module.id] = function(parentElement)
{
  new searchResults(parentElement)
}

export default searchResults



// WEBPACK FOOTER //
// ./vendor/response200/kustantajat/applications/publicFrontend/scripts/components/searchResults.js